import { MouseEvent, useState } from "react"
import { Divider, IconButton, Menu, MenuItem } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import type { TranslationKey } from "../../../../localization/translations"

const useStyles = makeStyles()((theme) => ({
    inactivateItem: {
        color: theme.palette.tailwind.red[600],
    },
}))

type MenuItemConfig = Readonly<{
    id: TranslationKey
    label: string
    onSelect: () => void
}>

type Props = Readonly<{
    isInactive: boolean
    isEmbeddable: boolean
    onPreview: () => void
    onOpenLink: () => void
    onResetLink: () => void
    onToggleInactive: () => void
}>

export function InfoDisplayCardMenu({
    isInactive,
    isEmbeddable,
    onPreview,
    onOpenLink,
    onResetLink,
    onToggleInactive,
}: Props) {
    const { classes } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const open = Boolean(anchorEl)

    const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleItemClick = (onSelect: () => void) => () => {
        handleMenuClose()
        onSelect()
    }

    const menuItems: ReadonlyArray<MenuItemConfig> = [
        { id: "merchant-info-displays-menu-preview-item", label: "Preview", onSelect: onPreview },
        isEmbeddable
            ? { id: "merchant-info-displays-menu-link-item", label: "Permalink / embed", onSelect: onOpenLink }
            : { id: "merchant-info-displays-menu-permalink-item", label: "Permalink", onSelect: onOpenLink },
        { id: "merchant-info-displays-menu-reset-item", label: "Reset", onSelect: onResetLink },
    ]

    return (
        <>
            <IconButton size="small" onClick={handleMenuOpen}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {menuItems.map((item) => (
                    <LocalizedStrict key={item.id} id={item.id}>
                        <MenuItem onClick={handleItemClick(item.onSelect)}>{item.label}</MenuItem>
                    </LocalizedStrict>
                ))}
                <Divider />
                <LocalizedStrict
                    id={
                        isInactive
                            ? "merchant-info-displays-menu-activate-item"
                            : "merchant-info-displays-menu-inactivate-item"
                    }
                >
                    <MenuItem className={classes.inactivateItem} onClick={handleItemClick(onToggleInactive)}>
                        Inactivate
                    </MenuItem>
                </LocalizedStrict>
            </Menu>
        </>
    )
}
